module.exports = __webpack_public_path__ + "static/image1-a023bea7acc417222883e12de2649192.jpg";